import {
  AbsoluteCenter,
  Box,
  Flex,
  Image,
  Popover,
  useColorModeValue,
  useDisclosure
} from '@chakra-ui/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { COMMON_WEB_PATH } from '../../constant';
import useCheckLogin from '../../hook/useCheckLogin';
import BalanceContent from './BalanceContent';

const isCredit = process.env.REACT_APP_CREDIT == 1;
const Balance = () => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const { isMachineUser } = useCheckLogin();

  const linkColor = useColorModeValue('light.100', '#394367');

  const memberInfo = useSelector((state) => state.isMemberInfo);

  const { pathname } = useLocation();

  return (
    <Popover
      variant={'brandPrimary'}
      isOpen={isOpen}
      onClose={onClose}
      placement="bottom"
    >
      <Flex
        bgImage={`url('${COMMON_WEB_PATH}/blue-layout/header/balance_background.png')`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="113%100%"
        alignItems="center"
        gap="10px"
        minW={{
          base: '150px',
          md: '180px',
          xl: '245px'
        }}
        maxW={{
          base: '200px',
          md: '250px',
          xl: '300px'
        }}
        height={{
          base: '40px',
          md: '65px'
        }}
        position="relative"
        justifyContent={'center'}
        pl={{
          base: '2.3em',
          md: '3em',
          xl: '4em'
        }}
        pr={{
          base: '0.8em',
          md: '1em'
        }}
      >
        <Flex w="100%" direction={`column`} alignItems={`center`}>
          <Box
            onClick={() => {
              if (pathname.includes('gamebox')) {
                return;
              } else {
                if (isCredit) {
                  return;
                }
                onToggle();
              }
            }}
            display={`flex`}
            alignItems={`center`}
            w="100%"
            gap="5px"
            overflowX="scroll"
            // mb="10px"
          >
            <BalanceContent hiddenSymbol />
          </Box>
        </Flex>
      </Flex>
      {/* <WalletList onClose={onClose} /> */}
    </Popover>
  );
};

export default Balance;
